import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { canActivate, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';

const redirectUnauthorizedToHome = () => redirectUnauthorizedTo(['home/login']);
const redirectLoggedInToProg = () => redirectLoggedInTo(['prog/drawer']);


const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    ...canActivate(redirectLoggedInToProg)
  },
  {
    path: 'prog',
    loadChildren: () => import('./prog/prog.module').then(m => m.ProgModule),
    canActivate: [AuthGuard],
    ...canActivate(redirectUnauthorizedToHome)
  },
  {
    path: '',
    redirectTo: 'home/initialize',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
